import React from "react";
import AcControl from "../Pages/AcContorl";
import "./home.css";

const Accontroling = () => {
  return (
    <section className='home'>
      <div className='container'>
        <div className='heading flexSB'>
          <div className="flex items-center">
          </div>
        </div>
        <AcControl />
      </div>
    </section>
  );
};

export default Accontroling;
